import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classes from './DeliveryMap.css';
import * as actions from '../../store/actions/index';

var map = null;
var markers = [];
var green = "19d66b";
var red = "ff0000";
var hardwood = "deb887";
var black = "a9a9a9";
var cedar = 'f0e6ac'
var multiple = "ffefd5";

class DeliveryMap extends React.Component {
state = {
    markersSet: false
}
    componentDidMount() {
        console.log('display the map');
        console.log(document.getElementById('map'));
        map = new window.google.maps.Map(document.getElementById('map'), {
            center: { lat: 33.19501, lng: -96.67336 },
            zoom: 13,
            mapTypeId: 'roadmap',
        });

    }

    componentDidUpdate() {
        console.log("In Did Update");
        let lets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let bounds = new window.google.maps.LatLngBounds();
        if (markers.length == 0 || !this.state.markersSet) {
            if (this.props.delivery.orders.length > 0 && !this.props.loading) {
                for (let l in this.props.delivery.orders) {
                    let letter = lets.substr(l,1);
                  this.addMarker(map, this.props.delivery.orders[l],letter)
                  bounds.extend({lat: Number(this.props.delivery.orders[l].geoLat), lng: Number(this.props.delivery.orders[l].geoLon) })
                }
                this.setState({markersSet:true});
                map.fitBounds(bounds);
            }
        }
        else {
            console.log("OLD MAP");
            for (let l in this.props.orders) {
                this.checkMarker(map, this.props.delivery.orders[l])
            }
        }
    }

    checkMarker(map, order) {
        let color = "";
        let types = 0;
        let lets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let bags = order.hardwoodBags + order.cedarBags + order.blackBags + order.redBags;
        for (let k in markers) {
            let letter = lets.substr(k,1);
            let orderId = markers[k].title.substring(0, markers[k].title.indexOf(":"));
            if (orderId == order.orderId) {
   
                if (order.status == 'delivered') {
                    color = green;
                }
                else {                    
                    if (order.hardwoodBags > 0) {
                        types = types + 1;
                        color = hardwood;
                    }
                    if (order.cedarBags > 0) {
                        types = types + 1;
                        color = cedar;
                    }
                    if (order.blackBags > 0) {
                        types = types + 1;
                        color = black;
                    }
                    if (order.redBags > 0) {
                        types = types + 1;
                        color = red;
                    }

                    if (types > 1) {
                        color = multiple;
                    }
                }
                markers[k].icon.url = 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=0.75|0|' + color + '|10|_|' + letter;
            }
        }
    }

    toggleOrder(title) {
    }

    addMarker(map, order,letter) {
        let title = order.orderId + ":";
        let color = "";

        let types = 0;
        let bags = order.hardwoodBags + order.cedarBags + order.blackBags + order.redBags;

        if (order.hardwoodBags > 0) {
            title = title + ' Hardwood ' + order.hardwoodBags;
            types = types + 1;
            color = hardwood;
        }
        if (order.cedarBags > 0) {
            title = title + ' Cedar ' + order.cedarBags;
            types = types + 1;
            color = cedar;
        }
        if (order.blackBags > 0) {
            title = title + ' Black ' + order.blackBags;
            types = types + 1;
            color = black;
        }
        if (order.redBags > 0) {
            title = title + ' Red ' + order.redBags;
            types = types + 1;
            color = red;
        }

        if (types > 1) {
            color = multiple;
        }
        console.log(order.orderId + ":" + order.deliveryId);
        if (order.deliveryId > 0) {
            color = green;
        }
        
        title = title + ' bags';
        let marker = new window.google.maps.Marker({
            map: map,
            title: title,
            icon: { url: 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=0.75|0|' + color + '|10|_|' + letter },
            position: { lat: Number(order.geoLat), lng: Number(order.geoLon) },
        });
        marker.addListener('click', () => {
            this.toggleOrder({ title });
            //markers[0].setIcon({url: 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=0.75|0|aa0000|10|_|100'});
        })

        markers.push(marker);

    }


    render() {
        return (
            <div style={{ "height": "100%" }}>
                <div id='map' style={{ "height": "100%", marginTop:56 }} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        delivery: state.orders.delivery,
        isAuthenticated: state.orders.token !== null
    };
}


export default connect(mapStateToProps)(DeliveryMap);


// WEBPACK FOOTER //
// ./src/components/DeliveryMap/DeliveryMap.js